export default __webpack_public_path__ + "static/media/plat-volume-ar.089323c8.png";